import { render, staticRenderFns } from "./CellItem.vue?vue&type=template&id=3648f6ea&scoped=true&"
import script from "./CellItem.vue?vue&type=script&lang=js&"
export * from "./CellItem.vue?vue&type=script&lang=js&"
import style0 from "./CellItem.vue?vue&type=style&index=0&id=3648f6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648f6ea",
  null
  
)

export default component.exports